import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const ContactSourceParts = [
  'container',
  'labelText',
  'dataContainer',
  'iconContainer',
  'icon',
  'nameText',
  'pmsText',
] as const

const helpers = createMultiStyleConfigHelpers(ContactSourceParts)

export const ContactSourceStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      paddingY: '1.25rem',
      gap: '0.5rem',
    },
    labelText: {
      ...textStyles[textStyleKeys.Body1],
    },
    dataContainer: {
      gap: '0.5rem',
      alignItems: 'center',
    },
    iconContainer: {
      justifyContent: 'center',
      alignItems: 'center',
      boxSize: '2.25rem',
      borderRadius: '0.5rem',
      border: '1px solid',
      borderColor: 'border.default',
      gap: '0.5rem',
    },
    icon: {
      boxSize: '1.5rem',
    },
    nameText: {
      ...textStyles[textStyleKeys.Body1],
    },
    pmsText: {
      ...textStyles[textStyleKeys.Body1],
    },
  },
})

export const useContactSourceStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(ContactSourceStyle, props) as MultiStyleType<
    typeof ContactSourceParts
  >
}
